import React from 'react'
import { Image, Modal } from "react-bootstrap";
import search from '../assets/Icon/search.png'

function Modals({ handleClose, show, children }) {
    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="d-flex flex-column text-center rgc-modal-content">
                        <div>
                            <Image src={search} alt="search" />
                        </div>
                        {children}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Modals